import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=45cf5748&scoped=true&"
import script from "./MemberAddress.vue?vue&type=script&lang=js&"
export * from "./MemberAddress.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddress.vue?vue&type=style&index=0&id=45cf5748&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf5748",
  null
  
)

export default component.exports